export default "<p>galerie works!</p>\n"